import gql from 'graphql-tag';
import { ACCOUNT_FRAGMENT } from './fragments';

export const createAccountMutation = gql`
  mutation CreateAccountMutation($input: CreateAccountInput!) {
    createAccount(input: $input) {
      account {
        ...AccountFields
      }
      notebook {
        id
      }
      errors {
        path
        message
      }
    }
  }
  ${ACCOUNT_FRAGMENT}
`;

export const editAccountMutation = gql`
  mutation EditAccountMutation($input: EditAccountInput!) {
    editAccount(input: $input) {
      account {
        ...AccountFields
      }
    }
  }
  ${ACCOUNT_FRAGMENT}
`;

export const inviteUserToAccountMutation = gql`
  mutation InviteUserToAccountMutation($input: InviteUserInput!) {
    inviteUserToAccount(input: $input) {
      invitation {
        id
        inviteCode
        invitedMember {
          id
        }
      }
      errors {
        path
        message
      }
    }
  }
`;

export const accountInvitationQuery = gql`
  query AccountInvitationQuery($inviteCode: String!) {
    findAccountInvitation(inviteCode: $inviteCode) {
      id
      inviteCode
      invitedBy {
        id
        displayName
      }
      invitedMember {
        id
        user {
          email
          isConfirmed
        }
        displayName
        roleType
        membershipStatus
      }
      acceptedOn
      revokedOn
      inviteLink
    }
  }
`;

export const acceptAccountMembershipMutation = gql`
  mutation AcceptAccountMembershipMutation($input: AcceptAccountMembershipInput!) {
    acceptAccountMembership(input: $input) {
      member {
        id
        displayName
        membershipStatus
        roleType
      }
      user {
        id
        email
      }
    }
  }
`;

export const revokeAccountInvitiationMutation = gql`
  mutation RevokeAccountInvitiationMutation($id: ID!) {
    revokeAccountInvitation(id: $id) {
      id
      inviteCode
      revokedOn
    }
  }
`;

export const inactivateAccountMembershipMutation = gql`
  mutation InactivateAccountMembershipMutation($id: ID!) {
    inactivateAccountMembership(id: $id) {
      membershipStatus
    }
  }
`;

export const membershipQuery = gql`
  query MembershipQuery($accountId: ID!) {
    findMembership(accountId: $accountId) {
      id
      displayName
      membershipStatus
      roleType
      reportsTo {
        id
        displayName
      }
    }
  }
`;

export const accountQuery = gql`
  query AccountQuery($id: ID!) {
    account(id: $id) {
      ...AccountFields
    }
  }
  ${ACCOUNT_FRAGMENT}
`;

export const accountsQuery = gql`
  query AccountsQuery {
    accounts {
      ...AccountFields
    }
  }
  ${ACCOUNT_FRAGMENT}
`;

export const accountMembersQuery = gql`
  query AccountMembersQuery($input: AccountMembersInput!) {
    accountMembers(input: $input) {
      id
      displayName
      reportsTo {
        id
        displayName
      }
      user {
        id
        email
        isAdmin
      }
      membershipStatus
      roleType
    }
  }
`;

export const accountInvitationsQuery = gql`
  query AccountInvitationsQuery($input: AccountInvitationsInput!) {
    accountInvitations(input: $input) {
      id
      inviteCode
      invitedBy {
        id
        displayName
      }
      invitedMember {
        id
        displayName
        user {
          email
        }
        membershipStatus
        roleType
      }
      acceptedOn
      revokedOn
    }
  }
`;

export const editAccountMembership = gql`
  mutation EditAccountMembership($input: EditAccountMembershipInput!) {
    editAccountMembership(input: $input) {
      member {
        id
        displayName
        membershipStatus
        roleType
        reportsTo {
          id
          displayName
        }
        user {
          id
          email
          isAdmin
        }
      }
      errors {
        path
        message
      }
    }
  }
`;

export const changeMembershipPermissions = gql`
  mutation ChangeMembershipPermissions($input: ChangeMembershipPermissionsInput!) {
    changeMembershipPermissions(input: $input) {
      member {
        id
        displayName
        membershipStatus
        roleType
      }
      errors {
        path
        message
      }
    }
  }
`;
